/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками DTMF
 */

/**
 * Сервис управления настройками DTMF
 */
export class DtmfSettingsServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек DTMF
   */
  EditDtmfSettings = (req: Pick<EditDtmfSettingsRequestDto, "updateMask"> & { data: DtmfSettingsRequestDto & fm.RequireAtLeastOne<DtmfSettingsRequestDto> }, init?: RequestInit): Promise<EditDtmfSettingsResponseDto> => {
    return fm.request<Pick<EditDtmfSettingsRequestDto, "updateMask"> & { data: DtmfSettingsRequestDto & fm.RequireAtLeastOne<DtmfSettingsRequestDto> }, EditDtmfSettingsResponseDto>(`${this.host}/device/api/v1/dtmf/settings`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек DTMF
   */
  GetDtmfSettings = (req?: GetDtmfSettingsRequestDto, init?: RequestInit): Promise<GetDtmfSettingsResponseDto> => {
    return fm.request<GetDtmfSettingsRequestDto, GetDtmfSettingsResponseDto>(`${this.host}/device/api/v1/dtmf/settings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Настройки DTMF
 */
export type DtmfSettingsRequestDto = {
  /**
   * Флаг приема DTMF сигнала в варианте RFC
   */
  isRfcOn?: boolean
  /**
   * Флаг приема DTMF сигнала в варианте inbound
   */
  isInboundOn?: boolean
  /**
   * Флаг приема DTMF сигнала в варианте sipinfo
   */
  isSipinfoOn?: boolean
}
/**
 * Настройки DTMF
 */
export type DtmfSettingsResponseDto = {
  /**
   * Флаг приема DTMF сигнала в варианте RFC
   */
  isRfcOn: boolean
  /**
   * Флаг приема DTMF сигнала в варианте inbound
   */
  isInboundOn: boolean
  /**
   * Флаг приема DTMF сигнала в варианте sipinfo
   */
  isSipinfoOn: boolean
}
/**
 * Запрос редактирования настроек DTMF
 */
export type EditDtmfSettingsRequestDto = {
  /**
   * Настройки DTMF
   */
  data: DtmfSettingsRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек DTMF
 */
export type EditDtmfSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditDtmfSettingsResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditDtmfSettingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditDtmfSettingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек DTMF
 */
export type GetDtmfSettingsRequestDto = {
}
/**
 * Ответ на запрос получения настроек DTMF
 */
export type GetDtmfSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки DTMF
   */
  readonly data: DtmfSettingsResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Настройки DTMF
   */
  "DtmfSettings": {
    "kind": "class",
    "text": "Настройки DTMF",
    "fields": {
      /**
       * Флаг приема DTMF сигнала в варианте RFC
       */
      "isRfcOn": {
        "type": "bool",
        "text": "Флаг приема DTMF сигнала в варианте RFC",
      },
      /**
       * Флаг приема DTMF сигнала в варианте inbound
       */
      "isInboundOn": {
        "type": "bool",
        "text": "Флаг приема DTMF сигнала в варианте inbound",
      },
      /**
       * Флаг приема DTMF сигнала в варианте sipinfo
       */
      "isSipinfoOn": {
        "type": "bool",
        "text": "Флаг приема DTMF сигнала в варианте sipinfo",
      },
    },
  },
  /**
   * Запрос редактирования настроек DTMF
   */
  "EditDtmfSettingsRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек DTMF",
    "fields": {
      /**
       * Настройки DTMF
       */
      "data": {
        "type": "DtmfSettings",
        "text": "Настройки DTMF",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек DTMF
   */
  "EditDtmfSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек DTMF",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditDtmfSettingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditDtmfSettingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек DTMF
   */
  "GetDtmfSettingsRequest": {
    "kind": "class",
    "text": "Запрос получения настроек DTMF",
  },
  /**
   * Ответ на запрос получения настроек DTMF
   */
  "GetDtmfSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек DTMF",
    "fields": {
      /**
       * Настройки DTMF
       */
      "data": {
        "type": "DtmfSettings",
        "text": "Настройки DTMF",
      },
    },
  },
}